import React, { Component } from 'react';
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/organizers/';
const event_img_path = 'https://www.kinshipliving.com/images/uploads/kinship/events/';



export default class OrganizerDetailPage extends Component {
    // constructor() {
    //     super();
    // }

        HandleDate = (startDate)=>{
        startDate = startDate.replace(/  /g,'T')
        const dayArray = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        const monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
         let final_date;
         var day = new Date(startDate).getDay();
         var date = new Date(startDate).getDate();
         var month = new Date(startDate).getMonth();

         final_date = dayArray[day]+','+monthArray[month] + ' ' + date;

         return final_date;
    }

    HandleTime = (startTime)=>{
        startTime = startTime.replace(/  /g,'T')
        var hr = new Date(startTime).getHours();
        var min = new Date(startTime).getMinutes();
        let final;

        if (hr > 12) {
            hr = hr - 12
            if (min < 10) {
                min = '0' + min;
            }
            final = hr + ':' + min + ' ' + 'PM';
        }
        else {
            if (min < 10) {
                min = '0' + min;
            }
            final = hr + ':' + min + ' ' + 'AM';
        }

         return final;
    }



    render() {
        return (
            <div className='organizer-details-main'>
                <div className='container-fluid'>
                    <div className='organizer-details-head'>
                        <h3>{this.props.mystate.organizer_name}</h3>
                    </div>
                    {this.props.mystate.organizer_name !== '' ?
                        <div className='row'>
                            <div className='col-12 col-sm-6 col-md-5 col-lg-4'>
                                <div className='card organizer-profile-div'>
                                    <div className='organizer-category'>
                                        <p>{this.props.mystate.organizer_category}</p>
                                    </div>
                                    <div className='organizer-pic'>
                                        <img src={img_path + this.props.mystate.organizer_img.replace(',', '')} alt='loading...' />
                                    </div>
                                    <div className='organizer-rating'>
                                        <p>5</p>
                                        <i class="fa fa-lg fa-star" aria-hidden="true"></i>
                                    </div>

                                    <div className='organizer-name'>
                                        <p>{this.props.mystate.organizer_name}</p>
                                    </div>

                                </div>
                            </div>

                            <div className='col-12 col-sm-6 col-md-7 col-lg-8'>
                                <div className='card organizer-about'>
                                    <div className='organizer-about-head'>
                                        <h5>About the Organizer</h5>
                                    </div>
                                    <div className='organizer-about-info'>
                                        <p>{this.props.mystate.organizer_desc}</p>
                                    </div>
                                </div>
                                <div className='organizer-session-list-div'>
                              
                                    <h4>Sessions by {this.props.mystate.organizer_name}</h4>
                                    <div className='organizer-session-list'>
                                        {  
                                            this.props.event_list.length > 0 ?

                                                this.props.event_list.map((items, i) =>
                                                    <div className='card session-main-div'>
                                                        <div className='row'>
                                                            <div className='col-md-5 col-lg-5'>
                                                            <div className='session-img'>
                                                            <img src={event_img_path + items.event_image.replace(',' , '')} alt='loading...'/>
                                                            </div>

                                                            </div>
                                                            <div className='col-md-7 col-lg-7'>
                                                            <div className='session-info-div'>
                                                            <div className='row'>
                                                            <div className='col-6 col-md-6 col-lg-6'>
                                                            <div className='session-info'>
                                                            <h5>{items.event_name}</h5>
                                                            <p>{items.event_duration} mins</p>
                                                            <p>{items.event_language}</p>

                                                            </div>
                                                           
                                                            </div>
                                                            <div className='col-6 col-md-6 col-lg-6'>
                                                            <div className='session-info'>
                                                            <h5>{this.HandleDate(items.event_start_time)}</h5>
                                                            <h5>{this.HandleTime(items.event_start_time)}</h5>
                                                            </div>
                                                            
                                                            </div>
                                                            <div className='col-12'>
                                                            <div className='session-details-btn-div'>
                                                            <button type='button' className='btn' onClick={() => this.props.HandleRouting(`session-details/${items.seo_url}`)}>Details</button>
                                                            </div>
                                                            </div>
                                                            </div>
                                                            </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                )

                                                : ''}

                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''}

                </div>

            </div>
        )
    }
}

